import Vue from 'vue';
import Router from 'vue-router';
import $store from '../store/index';

import PremiumPage from '../pages/PremiumUpsell.vue';
import LandingPage from '../pages/Home.vue';
import InternationalPage from '../pages/international/International.vue';

function requireAuth(to, from, next) {
  if ($store.getters.loggedIn) {
    next();
  } else if (to.path === '/account/subscription') {
    next({ path: '/signin', query: { redirect: to.fullPath } });
  } else {
    next({ path: '/signup', query: { redirect: to.fullPath } });
  }
}

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: __dirname,
  scrollBehavior() {
    document.querySelector('body').scrollTop = 0;
    return { x: 0, y: 0 };
  },
  routes: [
    { name: 'Premium Page', path: '/premium', component: PremiumPage },
    {
      name: 'Landing Page',
      path: '/',
      beforeEnter: (to, from, next) => {
        if ($store.getters.loggedIn && $store.getters.user) {
          next({ path: '/listen' });
        } else {
          next();
        }
      },
      component: LandingPage,
    },
    {
      name: 'settings_account',
      path: '/account',
      component: () => import('../pages/Account'),
      beforeEnter: requireAuth,
      children: [
        { name: 'My Account - Info', path: 'info', component: () => import('../pages/account/Info') },
        { name: 'My Account - Feedback', path: 'feedback', component: () => import('../pages/account/Feedback') },
        { name: 'My Account - Subscriptions', path: 'subscription', component: () => import('../pages/account/Subscriptions') },
      ],
    },
    {
      path: '/listen',
      component: () => import('../pages/Discover.vue'),
      children: [
        { name: 'home', path: '/', component: () => import('../pages/discover/Index.vue') },
        { name: 'search', path: 'search', component: () => import('../pages/Search.vue') },
        {
          name: 'Library',
          path: '',
          component: () => import('../pages/user_library/Index.vue'),
          children: [
            { name: 'user_shows', path: 'my-shows', component: () => import('../pages/user_library/Shows.vue') },
            { name: 'user_shows', path: 'my-shows/list', component: () => import('../pages/user_library/PodcastEpisodes.vue') },
            { name: 'user_playlist', path: 'bookmarks', component: () => import('../pages/user_library/Episodes.vue') },
          ],
        },
        { name: 'categories_all', path: 'categories', component: () => import('../pages/Categories') },
        {
          name: 'category_detail', path: 'category/:categoryName/:categoryID', component: () => import('../pages/CategoryDetail'), meta: { title: 'categoryPage' },
        },
        {
          name: 'publisher_detail', path: ':publisher_slug/:publisherID', component: () => import('../pages/CategoryDetail'), meta: { title: 'publisherPage' },
        },
        { name: 'show_detail', path: ':publisher_slug/:show_slug/:podcastID', component: () => import('../pages/ShowDetails') },
        { name: 'episode_detail', path: ':publisher_slug/:show_slug/:episode_slug/:episodeID', component: () => import('../pages/EpisodeDetails') },
      ],
    },
    {
      path: '',
      component: () => import('../pages/Onboarding.vue'),
      children: [
        {
          name: 'account_create',
          path: '/signup',
          beforeEnter: (to, from, next) => {
            if ($store.getters.loggedIn && $store.getters.user && $store.getters.user.is_subscribed) {
              next({ path: '/account/subscription' });
            } else if ($store.getters.loggedIn) {
              next({ path: '/premium-buy' });
            } else {
              next();
            }
          },
          component: () => import('../pages/onboarding/SignUp.vue'),
        },
        { name: 'Verify', path: '/verify', component: () => import('../pages/onboarding/Verify.vue') },
        { name: 'sign_in', path: '/signin', component: () => import('../pages/onboarding/SignIn.vue') },
        { name: 'Forgot Password', path: '/forgotPassword', component: () => import('../pages/onboarding/ForgotPassword.vue') },
        { name: 'onboarding_demographics', path: '/user-info', component: () => import('../pages/onboarding/Info.vue') },
        { name: 'onboarding_topics', path: '/user-categories', component: () => import('../pages/onboarding/Categories.vue') },
        { name: 'Onboarding Shows', path: '/user-shows', component: () => import('../pages/onboarding/Shows.vue') },
        { name: 'Onboarding Complete', path: '/complete', component: () => import('../pages/onboarding/Complete.vue') },
        { name: 'Premium Info', path: '/premium-info', component: () => import('../pages/onboarding/PremiumInfo.vue') },
        {
          name: 'Premium Subscribe',
          path: '/premium-buy',
          beforeEnter: requireAuth,
          component: () => import('../pages/onboarding/AdyenBuyPremium.vue'),
        },
        {
          path: '',
          redirect: '/listen',
        },
      ],
    },
    { name: 'All Exclusives', path: '/exclusives', component: () => import('../pages/Exclusives') },
    {
      name: 'My Account Settings',
      path: '/account',
      component: () => import('../pages/Account'),
      beforeEnter: requireAuth,
      children: [
        { name: 'My Account Settings - Info', path: 'info', component: () => import('../pages/account/Info') },
        { name: 'My Account Settings - Feedback', path: 'feedback', component: () => import('../pages/account/Feedback') },
        { name: 'My Account Settings - Subscriptions', path: 'subscription', component: () => import('../pages/account/Subscriptions') },
      ],
    },
    { name: 'Change Password', path: '/account/updatepassword', component: () => import('../pages/account/UpdatePassword') },
    { name: 'Password reset', path: '/resetpassword', component: () => import('../pages/ResetPassword') },
    { name: 'About', path: '/about', component: () => import('../pages/About.vue') },
    { path: '/contact', component: () => import('../pages/Contact.vue') },
    { name: 'FAQs', path: '/faqs', component: () => import('../pages/FAQ.vue') },
    { name: 'Privacy', path: '/privacy', component: () => import('../pages/Privacy.vue') },
    { name: 'All Publishers Page', path: '/publishers', component: () => import('../pages/Publishers.vue') },
    { name: 'Terms', path: '/terms', component: () => import('../pages/Terms.vue') },
    { name: 'Terms Free Trial', path: '/termsfreetrial', component: () => import('../pages/TermsFreeTrial.vue') },
    { name: 'Home Screen - Bundle Preview', path: '/bundle/:bundle_id', component: () => import('../pages/discover/Index.vue') },
    { name: 'Premium Upsell', path: '/premium-upsell', component: () => import('../pages/PremiumUpsell.vue') },
    { name: 'Premium Shows', path: '/shows', component: () => import('../pages/PremiumShows.vue') },
    { name: 'International', path: '/international', component: InternationalPage },
    { name: 'Careers', path: '/careers', component: () => import('../pages/careers/Careers.vue') },
    { name: 'JobDetails', path: '/job/:jobId', component: () => import('../pages/careers/JobDetail.vue') },
    { name: '404', path: '/not-found/404', component: () => import('../pages/404.vue') },
    { path: '*', component: () => import('../pages/404.vue') },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./app/src/router/index.js